import { User } from '~/src/types/api'

const getUserFullName = (user: User | null): string => {
  if (!user) return ''
  return [user.first_name, user.last_name].filter(Boolean).join(' ')
}

export { getUserFullName }
